import React from 'react'

// Material UI
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'
import { removeFromCart } from '../../redux/actions/cartActions'

const CartRemoveDialog = ({ open, item, handleDialog, clientData, removeFromCart }) => {

  const { language } = clientData

  const handleItemRemove = () => {
    handleDialog()
    removeFromCart(item.guid)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialog}
      >
        <DialogTitle>{Language.CartItemDeleteMessage[language]} {item.name} ?</DialogTitle>
        <DialogActions>
          <Button onClick={handleDialog} color="primary">
            {Language.CartDialogMessageRemovalNo[language]}
          </Button>
          <Button onClick={handleItemRemove} color="primary" autoFocus>
            {Language.CartDialogMessageRemovalYes[language]}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    removeFromCart: (item) => dispatch(removeFromCart(item))
  }
}

const mapStateToProps = state => {
  return {
    clientData: state.clientData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartRemoveDialog)